class SubscriptionUpgrade extends HTMLElement {
    constructor() {
        super();
    }
    
    connectedCallback() {
        this.upgradeButtons = this.querySelectorAll("button.subscription-upgrade__option__button");
        this.upgradeButtons.forEach(button => button.addEventListener("click", this.onUpgradeButtonClick.bind(this)));

        this.upgradeRadioButtons = this.querySelectorAll("input.subscription-upgrade__option__input");
        this.upgradeRadioButtons.forEach(button => button.addEventListener("change", this.onUpgradeButtonClick.bind(this)));

        this.undoButton = this.querySelector("button.subscription-upgrade__undo__button");
        if (this.undoButton) {
            this.undoButton.addEventListener("click", this.onUndoButtonClick.bind(this));
        }
    }

    disconnectedCallback() {
        this.upgradeButtons.forEach(button => button.removeEventListener("click", this.onUpgradeButtonClick.bind(this)));
        this.upgradeRadioButtons.forEach(button => button.removeEventListener("change", this.onUpgradeButtonClick.bind(this)));
        if (this.undoButton) {
            this.undoButton.removeEventListener("click", this.onUndoButtonClick.bind(this));
        }
    }

    onUpgradeButtonClick(event) {

        event.preventDefault();
        this.upgradeButtons.forEach(button2 => button2.disabled = true);
        const button = event.target,
            removeKey = button.dataset.upgradeKeyRemove,
            upgradeVariantId = button.dataset.upgradeVariantId,
            upgradeSellingPlan = button.dataset.upgradeSellingPlan,
            form = button.closest("form");

        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: removeKey,
                quantity: 0
            })
        }).then(response => response.json()).then(cart => {
            setTimeout(() => {
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: [{
                            id: upgradeVariantId,
                            quantity: 1,
                            selling_plan: upgradeSellingPlan
                        }]
                    })
                }).then(response => response.json()).then(itemAddedData => {
                    if (document.body.classList.contains("template-cart")) {
                        window.location.reload();
                    } else {
                        // refresh_cart(null);
                        setTimeout(() => {
                            // cartLoader.classList.remove("subscription-upgrade-loading");
                        }, 250);
                    }
                    document.dispatchEvent(new CustomEvent("cart:item:added"));
                }).catch(error => {
                    console.error(error);
                });
            }, 500);
        }).catch(error => {
            console.error(error);
        });
    }

    onUndoButtonClick(event) {
        event.preventDefault();
        this.undoButton.disabled = true;
        const button = event.target,
            undoVariantId = button.dataset.undoVariantId,
            undoSellingPlan = button.dataset.undoSellingPlan,
            undoDiscount = button.dataset.undoDiscount,
            removeKey = button.dataset.keyRemove,
            form = button.closest("form");

        let addBody = {
            id: undoVariantId,
            quantity: 1
        };
        if (undoSellingPlan && undoDiscount) {
            addBody.properties = {
                _og_subscription: "true",
                _og_discount: undoDiscount
            };
            addBody.selling_plan = undoSellingPlan;
        }

        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: removeKey,
                quantity: 0
            })
        }).then(response => response.json()).then(cart => {
            console.log(cart);
            setTimeout(() => {
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: [addBody]
                    })
                }).then(response => response.json()).then(itemAddedData => {
                    if (document.body.classList.contains("template-cart")) {
                        window.location.reload();
                    } else {
                        // refresh_cart(null);
                        setTimeout(() => {
                            // cartLoader.classList.remove("subscription-upgrade-loading");
                        }, 250);
                    }
                    document.dispatchEvent(new CustomEvent("cart:item:added"));
                }).catch(error => {
                    console.error(error);
                });
            }, 500);
        }).catch(error => {
            console.error(error);
        });
    }
}


["rebuy:smartcart.ready"].forEach(ev => {
  document.addEventListener(ev, () => {
    console.log("Rebuy Smart Cart Event");
    customElements.get("subscription-upgrade") || customElements.define("subscription-upgrade", SubscriptionUpgrade);
});
})


